var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full bg-gray-200 rounded-full h-2.5"},[_c('div',{staticClass:"bg-primary h-2.5 rounded-full",style:(("width: " + _vm.progress + "%; transition: width 2s"))})])}
var staticRenderFns = []

export { render, staticRenderFns }